<template>
  <a-modal
    :visible="imgVisible"
    :destroy-on-close="true"
    :footer="null"
    title="导出"
    :maskClosable="false"
    centered
    width="700"
    :bodyStyle="{padding:'25px',backgroundColor:'#5D5D5D', backgroundSize: '100% 100%'}"
    class="export-modal"
    @cancel="hide"
  >
    <span class="icon-icon_close_18_n" slot="closeIcon"></span>
    <div class="export-content" id="exportPng">
    </div>
    <div class="footer">
      <a-button type="primary" @click="exportImage">导出png</a-button>
    </div>
  </a-modal>
</template>

<script >
const PIXI = window.PIXI
export default {
  name: 'ExportPng',
  props: {
    image: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgVisible: false,
      p_x: '',
      p_y: '',
      pStart_x: '',
      pStart_y: '',
      app: {},
      personContain: {}
    }
  },
  components: {},
  computed: {},
  created () {},
  mounted () {

  },
  methods: {
    init () {
      const app = new PIXI.Application(
        {
          width: '512',
          height: '600',
          autoResize: true,
          antialias: true,
          forceCanvas: true,
          transparent: true,
          resolution: window.devicePixelRatio || 1
        }
      )

      this.personContain = PIXI.Sprite.from(this.image)
      this.personContain.interactive = true
      this.personContain.scale.set(0.25)
      this.bgContain = new PIXI.Container()

      this.app = app
      document.querySelector('#exportPng').appendChild(app.view)
      this.app.stage.interactive = true
      this.app.stage.buttonMode = true
      this.loadHead()
      this.app.stage.addChild(this.bgContain)
      this.app.stage.addChild(this.personContain)

      // 模型拖拽
      this.personContain
        .on('pointerdown', e => {
          const currentTarget = e.currentTarget
          const { x, y } = e.data.global
          currentTarget.dragging = true
          this.p_x = x
          this.p_y = y
          this.pStart_x = currentTarget.x
          this.pStart_y = currentTarget.y
        })
        .on('pointermove', e => {
          const { x, y } = e.data.global
          const currentTarget = e.currentTarget
          if (currentTarget.dragging) {
            currentTarget.x = x - this.p_x + this.pStart_x
            currentTarget.y = y - this.p_y + this.pStart_y
          }
        })
        .on('pointerupoutside', (e) => {
          this.pointerupoutside(e)
        })
        .on('pointerup', (e) => {
          this.pointerupoutside(e)
        })
      const left = this.keyboard(37)
      const up = this.keyboard(38)
      const right = this.keyboard(39)
      const down = this.keyboard(40)
      left.press = () => {
        this.personContain.x -= 1
      }
      up.press = () => {
        this.personContain.y -= 1
      }
      right.press = () => {
        this.personContain.x += 1
      }
      down.press = () => {
        this.personContain.y += 1
      }
    },
    loadHead () {
      this.app.loader.add('chuman_head', 'img/lx-1.png').load(() => {
        const head = new PIXI.Sprite(
          this.app.loader.resources['chuman_head'].texture
        )
        head.alpha = 0.5
        head.width = 49
        head.height = 60
        head.x = 232
        head.y = 74
        // this.areaContain.pivot.set(256, 256)
        this.app.stage.addChild(head)
      })
    },
    showModal () {
      this.imgVisible = true
      this.$nextTick(() => {
        this.init()
        // this.clearSpace(this.image)
      })
    },
    hide () {
      this.imgVisible = false
    },
    pointerupoutside (e) {
      const currentTarget = e.currentTarget
      currentTarget.alpha = 1
      currentTarget.dragging = false
      this.personContain.interactive = true
    },
    exportImage () {
      this.$emit('exportImage', this.personContain)
    },
    keyboard (keyCode) {
      const key = {}
      key.code = keyCode
      key.isDown = false
      key.isUp = true
      key.press = undefined
      key.release = undefined
      // The `downHandler`
      key.downHandler = event => {
        if (event.keyCode === key.code) {
          if (key.isUp && key.press) key.press()
          key.isDown = true
          key.isUp = false
        }
        event.preventDefault()
      }
      // The `upHandler`
      key.upHandler = event => {
        if (event.keyCode === key.code) {
          if (key.isDown && key.release) key.release()
          key.isDown = false
          key.isUp = true
        }
        event.preventDefault()
      }
      // Attach event listeners
      window.addEventListener(
        'keydown', key.downHandler.bind(key), false
      )
      window.addEventListener(
        'keyup', key.upHandler.bind(key), false
      )
      return key
    }

  }
}
</script>

<style lang='less' >
.export-modal{
   .ant-modal-close-x {
        color: #999999;
    }
   /deep/
  .ant-modal-header{
     background-color: #5D5D5D;
     border-bottom: none;
     color: #fff;
     .ant-modal-title {
         color: #999999;
     }
  }
  .export-content {
    width: 512px;
    height: 600px;
  }
  .footer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
  }
}
</style>
